import { Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

import { idField } from 'utils/builder/fields';

export const jumpNavFields = [
  {
    name: 'label',
    type: 'string',
    defaultValue: 'Jump to',
    helperText: 'Text shown to the left of the tabs.',
  },
  {
    name: 'items',
    type: 'list',
    required: true,
    helperText: 'Navigation items for the bar. Use #section-id for on-page anchors, or full URLs for external links.',
    subFields: [
      idField,
      {
        name: 'label',
        type: 'string',
        required: true,
        defaultValue: 'Overview',
        helperText: 'Tab label.',
      },
      {
        name: 'href',
        type: 'string',
        defaultValue: '#overview',
        helperText: 'Anchor or URL to navigate to when clicked. For on-page sections, use #section-id.',
      },
    ],
  },

  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const jumpNavConfig = {
  name: 'JumpNav',
  inputs: jumpNavFields,
};

export type JumpNavConfig = GenerateBuilder<typeof jumpNavFields>;

export default jumpNavConfig;
